<template>
    <div class="i-surveys-form-input">
        <form-item v-bind="$attrs">
            <van-field
                v-model="modelValue"
                placeholder="请选择"
                :rules="rules"
                :readonly="true"
                :name="itemKey"
                @click-input="showPicker"
            >
                <!-- 添加清空按钮 -->
                <template #button>
                    <van-button 
                        v-if="modelValue && !isDisabled" 
                        size="small" 
                        type="primary" 
                        @click.stop="clearSelection"
                    >
                        清空
                    </van-button>
                </template>
            </van-field>
            <div style="color: #999999;font-size: 12px;margin-top: 4px;" v-if="modelValue" v-html="getLabel"> </div>
        </form-item>
        
        <van-popup v-model="show" position="bottom" style="height:50%">
            <div class="popup-header">
                <van-search
                    v-model="search"
                    show-action
                    placeholder="请输入"
                    @search="onSearch"
                    @cancel="onCancel"
                />
                <!-- 在弹窗中也添加清空选项 -->
                <div class="clear-option" @click="clearSelection">
                    <van-icon name="delete" />
                    <span>清空已选</span>
                </div>
            </div>
            
            <van-radio-group v-model="radio">
                <van-cell-group>
                    <van-cell v-for="item in columns" :key="item.value" :title="item.text" clickable @click="onClick(item)">
                        <template #right-icon>
                            <van-radio :name="item.value" checked-color="var(--color-primary)"/>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-popup>
    </div>
</template>

<script>
import FormItem from './form-item.vue'
import http from '@/http/index'

export default {
    components: { FormItem },
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        rules: {
            type: Array,
            default: () => ([])
        },
        itemKey: {
            type: String,
            default: ''
        },
        item:{
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        modelValue: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        },
        getLabel(){
            let item = this.allColumns.find(v=>v.name === this.modelValue)
            return item?`分类：${item.type} <br /> 级别：${item.level}`:''
        },
        isDisabled () {
            return this.$route.query.formType === 'preview'
        }
    },
    data(){
        return {
            search:'',
            loading:false,
            finished:true,
            show: false,
            radio:'',
            columns: [],
            allColumns:[]
        }
    },
    created(){
        this.getDataList()
    },
    methods:{
        // 清空选择
        clearSelection() {
            this.modelValue = ''
            this.radio = ''
            this.$emit('clear')
        },
        
        onSearch(){
            this.getDataList(this.search)
        },
        getDataList(name){
            this.loading = true
            this.finished = false
            
            http.get(`${process.env.VUE_APP_BASE_DM_URL}${this.item.path}`, {page: 1, limit: 1000,nameLike:name})
                .then(res => {
                    this.loading = false
                    this.finished = true
                    if(!res.code){
                        if(!this.allColumns.length){
                            this.allColumns = res.data.list
                        }
                        this.columns = res.data.list.map(item => {
                            return {
                                text: `${item.name}【${item.type} ${item.level}】`,
                                value: item.name
                            }
                        })
                    }
                })
                .catch(err => {
                    this.loading = false
                    this.finished = true
                    console.error(err)
                })
        },
        showPicker() {
            if(!this.isDisabled){
                this.show = true
                this.radio = JSON.parse(JSON.stringify(this.modelValue))
            }
        },
        onClick(value) {
            this.modelValue = value.value
            this.show = false
        },
        onCancel() {
            this.show = false
        }
    }
}
</script>

<style scoped>
.popup-header {
    position: relative;
}

.clear-option {
    position: absolute;
    right: 60px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    font-size: 14px;
    color: var(--color-primary);
    z-index: 1;
    padding: 8px;
    cursor: pointer;
}

.clear-option .van-icon {
    margin-right: 4px;
}
</style>